var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"estimationBody",staticClass:"estimate"},[[_c('div',[_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('descriptions.teams_zone_estimations')))])])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }